export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "electricGraphData.worker.992ff68f2cffe99c493a-electricGraphData.worker.worker.js");
}
